var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#19508A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55556 19.3591H9.6555L16.8995 12.115L15.7995 11.0151L8.55556 18.2591V19.3591ZM21 20.9146H7V17.6147L17.4494 7.1653C17.7532 6.86157 18.2457 6.86157 18.5494 7.1653L20.7493 9.36519C21.053 9.66893 21.053 10.1614 20.7493 10.4651L11.8554 19.3591H21V20.9146ZM16.8995 9.91517L17.9994 11.0151L19.0993 9.91517L17.9994 8.81522L16.8995 9.91517Z",
    fill: "#19508A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.33bbccd77ea66da969a8fa6ff49cce95.svg";
export { ForwardRef as ReactComponent };